import React from 'react';
import { SIZE, SKIN } from './VerticalTabs.constants';
export default React.createContext({
    size: SIZE.MEDIUM,
    skin: SKIN.LIGHT,
});
//# sourceMappingURL=VerticalTabsContext.js.map